import { Routes } from '@angular/router';
import { SecurityLoaders } from '@cfg/security/loaders';
import { RedirectToFirstMenuGuard } from '@adapter/security';
import { PreclinicalHomeComponent } from './preclinical/pages/home/home.component';
import { ComponentShowcaseComponent } from './component-showcase/component-showcase.component';
import { AccessDeniedComponent } from './shared/pages/access-denied/access-denied.component';
import { IngestedOrdersListComponent } from './preclinical/pages/ingested-orders/ingested-orders-list.component';
import { ReceivedOrdersListComponent } from './preclinical/pages/received-orders/received-orders-list.component';
import { AddSampleComponent } from './preclinical/pages/add-sample/legacy/add-sample.component';
import { ObservationsListComponent } from './preclinical/pages/observations/observations-list/observations-list.component';
import { TraceabilityListComponent } from './preclinical/pages/traceability/traceability-list/traceability-list.component';

/**
 * Application routes
 */
export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: PreclinicalHomeComponent,
    canActivate: [RedirectToFirstMenuGuard]
  },
  {
    path: 'home',
    pathMatch: 'full',
    component: PreclinicalHomeComponent,
    canActivate: [RedirectToFirstMenuGuard]
  },
  {
    path: 'preclinical/home',
    pathMatch: 'full',
    component: PreclinicalHomeComponent,
    canActivate: [RedirectToFirstMenuGuard]
  },
  {
    path: 'preclinical/ingested-orders',
    title: 'Órdenes Ingresadas',
    component: IngestedOrdersListComponent,
    canActivate: SecurityLoaders.loadGuards()
  },
  {
    path: 'preclinical/received-orders',
    title: 'Preingresos',
    component: ReceivedOrdersListComponent,
    canActivate: SecurityLoaders.loadGuards()
  },
  {
    path: 'preclinical/add-sample',
    title: 'Agregar Muestra',
    component: AddSampleComponent,
    canActivate: SecurityLoaders.loadGuards()
  },
  {
    path: 'general/observations',
    title: 'Observaciones',
    component: ObservationsListComponent,
    canActivate: SecurityLoaders.loadGuards()
  },
  {
    path: 'preclinical/traceability',
    title: 'Trazabilidad',
    component: TraceabilityListComponent,
    canActivate: SecurityLoaders.loadGuards()
  },
  {
    path: 'laboratory',
    loadChildren: () =>
      import('./laboratory/laboratory.routes').then((m) => m.laboratoryRoutes),
    canActivate: SecurityLoaders.loadGuards()
  },
  {
    path: 'administrative',
    loadChildren: () =>
      import('./administrative/administrative.routes').then(
        (m) => m.administrativeRoutes
      ),
    canActivate: SecurityLoaders.loadGuards()
  },
  
  {
    path: 'principales',
    loadChildren: () =>
      import('./result-validation/result-validation.routes').then(
        (m) => m.resultValidationRoutes
      ),
    canActivate: SecurityLoaders.loadGuards()    
    },
  {
    path: 'access-denied',
    title: 'Acceso Denegado',
    component: AccessDeniedComponent
  },
  {
    path: 'showcase',
    title: 'Component Showcase',
    component: ComponentShowcaseComponent
  }
];
